import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "../../pages/user/home/ui/Home";
import ScrollToTop from "../ui/scroll-to-top/ScrollToTop";
import Layout from "../ui/layout/Layout";
import AdminPost from "../../pages/admin/manage-article/add-article/ui/AdminPost";
import ModifyArticle from "../../pages/admin/manage-article/modify-article/ui/ModifyArticle";
import ProtectedRoute from "../../pages/admin/login/auth-guard/ProtectedRoute";
import AdminLayout from "../../pages/admin/layout/AdminLayout";
import ArticleManagement from "../../pages/admin/articles/ArticleManagement";
import CategoryManagement from "../../pages/admin/categories/CategoryManagement";
import KeywordManagement from "../../pages/admin/keywords/KeywordManagement";
import ProductManagement from "../../pages/admin/products/ProductManagement";
import AuthorManagement from "../../pages/admin/authors/AuthorManagement";

export default function Router() {
  return (
    <BrowserRouter basename="">
      <ScrollToTop />
      {/*<div className="dim"></div>*/}
      <Layout />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/detail/:id" element={<Home />} />
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <ArticleManagement />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/post"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <AdminPost />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/articles"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <ArticleManagement />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/categories"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <CategoryManagement />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/keywords"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <KeywordManagement />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/products"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <ProductManagement />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/authors"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <AuthorManagement />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/article/modify/:id"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <ModifyArticle />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}
